export default "__VITE_ASSET__DaB979SS__"